<template>
  <v-dialog v-model="dialog" scrollable>
    <v-card class="pv-planes-card">
      <!-- Header -->
      <div class="pv-planes-header" v-if="false">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-avatar color="rgba(255,255,255,0.15)" size="38">
            <v-icon color="white" size="22">mdi-cash-multiple</v-icon>
          </v-avatar>
          <div>
            <div class="pv-planes-title">Planes de Pago del Programa</div>
            <div class="pv-planes-sub">Detalle de conceptos, cuotas y promociones</div>
          </div>
        </div>
        <v-btn icon dark small @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Body -->
      <v-card-text class="pa-0">
        <v-tabs v-model="tab" background-color="cyan darken-3" centered dark icons-and-text>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1">
            Planes y promociones
            <v-icon>mdi-cash-multiple</v-icon>
          </v-tab>
          <v-tab href="#tab-2">
            Ver plan de pagos
            <v-icon>mdi-calendar</v-icon>
          </v-tab>
        </v-tabs>
        
        <v-tabs-items v-model="tab">
          <v-tab-item :value="'tab-'+1" :key="1" >
            <v-row>
              <v-col cols="12" sm="6">
                <h3>Planes de pagos disponibles:</h3>
                <div v-if="!planes || planes.length === 0" class="text-center py-8">
                  <v-icon size="48" color="grey lighten-1">mdi-cash-remove</v-icon>
                  <div class="text-subtitle-1 grey--text text--darken-1 mt-2">
                    No se encontraron planes de pago registrados para este programa.
                  </div>
                </div>

                <div v-else>
                  <v-row dense>
                    <v-col cols="12" v-for="(plan, index) in planes" :key="plan.plan_cobro_programa_id || index">
                      <v-card outlined class="pv-plan-item mb-8">
                        <v-card-title class="pv-plan-title py-0 px-4 d-flex justify-space-between align-center flex-wrap" style="gap: 8px;">
                          <div class="d-flex align-center flex-wrap" style="gap: 0px;">
                            <v-icon color="indigo darken-2" small>mdi-file-document-outline</v-icon>
                            <span class="font-weight-bold primary--text text--darken-3">{{ plan.nombre }}</span>
                          </div>

                          <!-- Creo que solo aparece aprobado, cuando al primer estudiante se le emite el recibo y se aprueba el plan -->
                          <!-- <div>
                            <v-chip v-if="plan.aprobado" small color="green" dark class="font-weight-medium">
                              <v-icon x-small left>mdi-check-circle</v-icon> Aprobado
                            </v-chip>
                            <v-chip v-else small color="amber darken-3" dark class="font-weight-medium">
                              <v-icon x-small left>mdi-clock-outline</v-icon> No Aprobado
                            </v-chip>
                          </div> -->
                        </v-card-title>

                        <v-divider class="my-0 py-0" />

                        <v-card-text class="px-3 pt-0">
                          <div class="pv-label mb-0 mt-0 px-1">Conceptos y Cuotas</div>
                          <v-simple-table dense>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">#</th>
                                  <th class="text-left">Concepto</th>
                                  <th class="text-center">Max. cuotas</th>
                                  <th class="text-right">Monto</th>
                                  <th class="text-center">Facturable</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(cobro, cIndex) in plan.cobros" :key="cobro.cobro_programa_id || cIndex">
                                  <td>{{ cIndex + 1 }}</td>
                                  <td>
                                    <div class="font-weight-medium">{{ cobro.nombre }}</div>
                                  </td>
                                  <td class="text-center">
                                    <v-chip x-small color="indigo lighten-5" class="indigo--text font-weight-medium">
                                      {{ cobro.cuotas }} {{ cobro.cuotas === 1 ? 'cuota' : 'cuotas' }}
                                    </v-chip>
                                  </td>
                                  <td class="text-right font-weight-bold">
                                    Bs. {{ parseMonto(cobro.monto) }}
                                  </td>
                                  <td class="text-center">
                                    <v-chip x-small :color="cobro.facturable ? 'blue lighten-5' : 'grey lighten-3'" :class="cobro.facturable ? 'blue--text text--darken-2' : 'grey--text text--darken-1'">
                                      {{ cobro.facturable ? 'Sí' : 'No' }}
                                    </v-chip>
                                  </td>
                                </tr>
                                <tr v-if="!plan.cobros || plan.cobros.length === 0">
                                  <td colspan="5" class="text-center grey--text py-3">Sin conceptos registrados</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="12" sm="6">
                <h3>Promociones disponibles:</h3>
                <v-row>
                  <v-col cols="12" v-for="(p, ind) in promos" :key="ind"> 
                    <v-card outlined class="pv-plan-item mb-3">
                      <v-card-title class="pv-plan-title py-0 px-4 d-flex justify-space-between align-center flex-wrap" style="gap: 8px;">
                        <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                          <v-icon color="indigo darken-2" small>mdi-file-document-outline</v-icon>
                          <span class="font-weight-bold primary--text text--darken-3">{{ p.nombre }}</span>
                        </div> 
                      </v-card-title>
                      <v-divider class="my-0 py-0"></v-divider>

                      <p class="my-0 pl-4"> {{ p.descripcion }} </p>
                      <p class="my-0 pl-8"> <b>Aprobado por:</b> <span v-if="ver_fechas_promos">{{ p.aprobado_por }}</span> <small class="grey--text">no disponible</small> </p>
                      <p class="my-0 pl-8"> <b>Desde:</b> <span v-if="ver_fechas_promos">{{ p.fecha_inicio }}</span> <small class="grey--text">no disponible</small> </p>
                      <p class="my-0 pl-8"> <b>Hasta:</b> <span v-if="ver_fechas_promos">{{ p.fecha_fin }}</span> <small class="grey--text">no disponible</small> </p>
                      <p class="my-0 pl-8" v-if="p.xmodalidad"> <b>Modalidad:</b> {{ p.xmodalidad }} </p>
                      <p class="my-0 pl-8" v-if="p.xplan_pago"> <b>Tipo plan:</b> {{ p.xplan_pago }} </p>

                      <v-simple-table dense >
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">#</th>
                              <th class="text-left">Concepto</th>
                              <th class="text-center">Valor descuento</th> 
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(cobro, cIndex) in p.detalle_promocion" :key="cobro.cobro_programa_id || cIndex">
                              <td>{{ cIndex + 1 }}</td>
                              <td>
                                <div class="font-weight-medium">{{ cobro.nombre_concepto }}</div>
                              </td>
                              <td class="text-center">
                                <v-chip x-small color="indigo lighten-5" class="indigo--text font-weight-medium">
                                  {{ cobro.valor_descuento }} {{ cobro.is_porcentaje ? '%' : '' }}
                                </v-chip>
                              </td>  
                            </tr> 
                          </tbody>
                        </template>
                      </v-simple-table> 
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>
          
          <v-tab-item :value="'tab-'+2" :key="2" >
            <h4 class="text-center"> Aquí puedes simular un plan de pagos para visualizar cómo quedaría el plan generado. Esta acción es solo una simulación y no realizará ningún registro </h4>
            <index_ins />
          </v-tab-item>
        </v-tabs-items>
        
      </v-card-text>

      <v-divider />

      <!-- Footer -->
      <v-card-actions class="px-4 py-2 bg-light">
        <v-spacer />
        <v-btn color="indigo darken-1" text @click="cerrar">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import index_ins from './prospectos1/inscripcion/index_ins.vue';
export default {
  name: 'ProgramaViewPlanes',
  components:{
    index_ins,
  },
  data() {
    return {
      dialog: false,
      tab: null,
      planes: [],
      promos: [],
    };
  },
  computed:{
    ver_fechas_promos(){
      const rol = this.$store.state.CARGO.id;
      const permitidos = [-1,11,14,15];
      return permitidos.includes(rol)
    }
  },
  methods: {
    open(planes, xpromos) {
      window.console.log('Programa-view-planes',planes, xpromos,this.$route.query);
      
      const list = planes ? [...planes] : [];
      list.sort((a, b) => (b.aprobado ? 1 : 0) - (a.aprobado ? 1 : 0));
      this.planes = list.filter(x=>x.estado);
      this.promos = xpromos
      this.dialog = true;
    },
    cerrar() {
      this.dialog = false;
    },
    parseMonto(val) {
      if (!val) return '0.00';
      const num = parseFloat(val);
      if (isNaN(num)) return val;
      return num.toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style scoped>
.pv-planes-header {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pv-planes-title {
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
}

.pv-planes-sub {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
}

.pv-plan-item {
  border-radius: 8px !important;
  border-color: #e3e8f0 !important;
  background-color: #ffffff;
}

.pv-plan-title {
  font-size: 0.9rem !important;
  background-color: #f8fafc;
}

.pv-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
}

.pv-cobros-table >>> table {
  width: 100%;
}

.pv-cobros-table >>> thead tr th {
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  color: #283593 !important;
  background-color: #f0f4ff !important;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.pv-cobros-table >>> tbody tr td {
  font-size: 0.82rem !important;
}
</style>
